    // src/app/modules/auth/login.service.ts
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { Observable } from 'rxjs';

export interface UserLogin {
  userCode: string;
  email: string;
}
@Injectable({ providedIn: 'root' })
export class LoginService {
  private readonly roleKey = 'user_role';

  constructor(private api: ApiService) {}

  login(request: { userName: string; password: string }): Observable<any> {
    return this.api.post('login', request);
  }

  logout(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem(this.roleKey);
    localStorage.removeItem('user_code');
  }

  saveToken(token: string): void {
    localStorage.setItem('auth_token', token);
  }

   saveUserCode(userCode: string): void {
    localStorage.setItem('user_code', userCode);
  }
  
  getUserCode(): string | null {
    return localStorage.getItem('user_code');
  }

  
  saveUserDetail(userDetail: string): void {
    localStorage.setItem('user_detail', userDetail);
  }

  getUserDetail(): any | null {
    const userDetail = localStorage.getItem('user_detail');
    return userDetail ? JSON.parse(userDetail) : null;
  }


  getToken(): string | null {
    return localStorage.getItem('auth_token');
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  saveRole(role: string): void {
    if (!role) {
      localStorage.removeItem(this.roleKey);
      return;
    }
    localStorage.setItem(this.roleKey, role.toLowerCase());
  }

  getRole(): string {
    return (localStorage.getItem(this.roleKey) || '').toLowerCase();
  }

  isUserRole(): boolean {
    return this.getRole() === 'user';
  }

  isAdminRole(): boolean {
    return this.getUserCode() === 'admin';
  }
}
